import { twJoin } from '@dynamika-shared/utils/twMerge';
import { useEffect, useState } from 'react';

type FilterButtonsProps = {
  filters: string[];
  selectedFilters?: string | string[];
  mode: 'single' | 'multiple';
  toggleSelectedFilter: (filter: string | string[]) => void;
};

export const FilterButtons = ({
  filters,
  mode,
  toggleSelectedFilter,
  selectedFilters: defaultSelectedFilters,
}: FilterButtonsProps) => {
  const [selectedFilters, setSelectedFilters] = useState<string[]>([]);

  const onToggle = (filter: string) => {
    if (mode === 'single') {
      if (selectedFilters.includes(filter)) {
        setSelectedFilters([]);
        toggleSelectedFilter([]);
      } else {
        setSelectedFilters([filter]);
        toggleSelectedFilter(filter);
      }
    } else {
      if (selectedFilters.includes(filter)) {
        setSelectedFilters(selectedFilters.filter(f => f !== filter));
        toggleSelectedFilter(selectedFilters.filter(f => f !== filter));
      } else {
        setSelectedFilters([...selectedFilters, filter]);
        toggleSelectedFilter([...selectedFilters, filter]);
      }
    }
  };

  useEffect(() => {
    if (defaultSelectedFilters) {
      setSelectedFilters(
        Array.isArray(defaultSelectedFilters)
          ? defaultSelectedFilters
          : [defaultSelectedFilters]
      );
    }
  }, [defaultSelectedFilters]);
  return (
    <div>
      {filters.map((filter, i) => (
        <button
          key={filter}
          onClick={() => {
            onToggle(filter);
          }}
          className={twJoin(
            ' px-[20px] py-[10px] rounded-[12px] text-1420 capitalize border',
            i !== 0 ? 'ml-1.5' : '',
            selectedFilters.includes(filter)
              ? 'bg-waterLight border-dodgerBlue'
              : 'bg-white'
          )}
        >
          {filter}
        </button>
      ))}
    </div>
  );
};
